<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="Edit2Icon"
			svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
			class="g-label--normal"
			@click="editRecord"
		/>
		<feather-icon
			v-if="visitpointDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			class="g-label--normal"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";

export default {
	name: "CellRendererActions",
	methods: {
		editRecord() {
			this.$router.push("/apps/visit-point/visit-point-edit/" + this.params.data.id).catch(() => {});
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: `${this.$t("VisitPointObject.List.CellRenderer.DeleteRecord")} "${this.params.data.name}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleVisitPoint/removeVisitPoint", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						//this.user_not_found = true;
						return;
					}
					throw new Error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("VisitPointObject.List.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("VisitPointObject.List.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	computed: {
		visitpointDeletePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_D");
		},
	},
	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
	},
};
</script>
